import { fetchCart } from "@/services/cart";
import { fetchFavorites } from "@/services/favorites";
import { CartItem } from "@/types/cart";
import { FavoriteItem } from "@/types/favorites";
import { createStore, createEvent, combine, createEffect } from "effector";

// Эффекты для API
export const fetchCartFx = createEffect(async () => {
  return (await fetchCart()).items;
});
export const fetchFavoritesFx = createEffect(async () => {
  return  (await fetchFavorites()).items;
});

// --- Корзина ---
export const setCartItems = createEvent<CartItem[]>();
export const addCartItem = createEvent<CartItem>();
export const removeCartItem = createEvent<string>(); // id

const $cartItems = createStore<CartItem[]>([])
  .on(setCartItems, (_, items) => items)
  .on(addCartItem, (state, item) => [...state, item])
  .on(removeCartItem, (state, id) => state.filter(item => item.id !== id))
  .on(fetchCartFx.doneData, (_, items) => items);

const $cartCount = $cartItems.map(items => items.length);

// --- Избранное ---
export const setFavoriteItems = createEvent<FavoriteItem[]>();
export const addFavoriteItem = createEvent<FavoriteItem>();
export const removeFavoriteItem = createEvent<string>(); // id

const $favoriteItems = createStore<FavoriteItem[]>([])
  .on(setFavoriteItems, (_, items) => items)
  .on(addFavoriteItem, (state, item) => [...state, item])
  .on(removeFavoriteItem, (state, id) => state.filter(item => item.id !== id))
  .on(fetchFavoritesFx.doneData, (_, items) => items);

const $favoriteCount = $favoriteItems.map(items => items.length);

// --- Обобщённый store ---
export const $shopState = combine({
  cart: combine({
    items: $cartItems,
    count: $cartCount,
  }),
  favorites: combine({
    items: $favoriteItems,
    count: $favoriteCount,
  }),
});